'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');

require("../../_assets/visuallyHidden-Dz533DiB.css");var visuallyHiddenStyles = {"visuallyHidden":"visuallyHidden___JHbMPr_4k__visuallyHidden"};

const VisuallyHidden = react.forwardRef(({ className, as, testId, ...props }, ref) => {
    const As = as ?? 'span';
    return (jsxRuntime.jsx(As, { className: utilities_combineClasses.combineClasses(className, visuallyHiddenStyles.visuallyHidden), "data-testid": testId, "data-component": "VISUALLY_HIDDEN" // Because there is no way to test visually hidden, we need this property to be able to assert if it is applied
        , ...props, ref: ref }));
});
VisuallyHidden.displayName = 'VisuallyHidden';

exports.VisuallyHidden = VisuallyHidden;
exports.visuallyHiddenStyles = visuallyHiddenStyles;
//# sourceMappingURL=VisuallyHidden.js.map
